import classnames from 'classnames';
import { CSSProperties, ReactNode } from 'react';
import styles from './index.module.css';

const { skeleton, animate } = styles;

interface SkeletonProps {
  count?: number;
  duration?: string;
  width?: string | number;
  wrapper?: (props: { children: ReactNode }) => JSX.Element;
  height?: string | number;
  circle?: boolean;
  style?: CSSProperties;
  className?: string;
}

/**
 * Docs: https://www.npmjs.com/package/react-loading-skeleton
 */
export function SkeletonLoading({
  count = 1,
  duration = '1.2s',
  width,
  wrapper: Wrapper,
  height,
  circle = false,
  style: customStyle,
  className: customClassName,
}: SkeletonProps) {
  const elements: ReactNode[] = [];

  for (let i = 0; i < count; i++) {
    const style: CSSProperties = {};

    if (width !== null && width !== undefined) {
      style.width = width;
    }

    if (height !== null && height !== undefined) {
      style.height = height;
    }

    if (width !== undefined && height !== undefined && circle) {
      style.borderRadius = '50%';
    }

    let className = 'react-loading-skeleton';
    if (customClassName) {
      className += ' ' + customClassName;
    }

    elements.push(
      <span
        key={i}
        className={classnames(className, skeleton, animate)}
        style={
          {
            ...customStyle,
            ...style,
            '--duration': duration,
          } as any
        }
      >
        &zwnj;
      </span>
    );
  }

  return (
    <span>
      {Wrapper
        ? elements.map((element, i) => (
            <Wrapper key={i}>
              {element}
              &zwnj;
            </Wrapper>
          ))
        : elements}
    </span>
  );
}
